<template>
    <uiFooter :blok="blok" />
</template>

<script setup>
defineProps({ blok: Object });
</script>

<style lang="postcss">
#sbFooter {
    @apply bg-[#f3f5f8] text-[#5a5e6b] tracking-[1.056px] leading-5 border-t-[#b9c6d0] border-t border-solid;

    .links-lists-container {
        @apply px-20 pt-12 justify-around text-sm;
        @apply max-md:pl-8 max-md:pr-8 max-md:flex max-md:flex-wrap max-md:justify-start;

        .links-col {
            @apply mb-8 max-md:flex-[50%];
        }
        .links-col-title {
            @apply font-bold text-[#5a5e6b] text-sm;
        }
        .links-list {
            .links-item {
                @apply text-[#5a5e6b];
                a {
                    @apply py-2 text-sm;
                    &:hover {
                        @apply text-[#5a5e6b] underline;
                    }
                }
            }
        }
    }

    .socials {
        @apply px-8 flex gap-x-4 justify-start md:justify-center md:px-20;
        .socials-text {
            @apply hidden;
        }
    }

    .copyright {
        @apply text-center mt-8 mb-0 mx-auto p-4 border-t-[#b9c6d0] border-t border-solid max-w-[450px] text-sm;
        @apply max-md:mx-0 max-md:max-w-full max-md:border-none max-md:text-[#b9c6d0] max-md:text-xs;
    }

    .footer-accordions {
        @apply hidden;
    }
}
</style>
